import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import toastr from 'toastr';
import { adminLogin } from '../api';
import md5 from 'md5';

export default function Login() {
  const [usuario, setUsuario] = useState('');
  const [senha, setSenha] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await adminLogin(usuario, md5(senha));
      if (res.SUCCESS) {
        localStorage.setItem('adminAuth', 'true');
        localStorage.setItem('adminToken', res.TOKEN);
        localStorage.setItem('adminUser', JSON.stringify(res.DATA));
        navigate('/admin');
      } else {
        toastr.error(res.MESSAGE || 'Usuário ou senha inválidos...');
      }
    } catch (err) {
      // erro já tratado pelo interceptador da api
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div style={{ textAlign: 'center', marginBottom: '1.25rem' }}>
          <div className="login-icon">🔐</div>
          <h2 className="login-title">Acesso Restrito</h2>
          <p className="login-subtitle">Painel de Administração</p>
        </div>
        <form onSubmit={handleLogin} className="login-form">
          <div className="mb-2">
            <label className="form-label fw-semibold">Usuário</label>
            <input
              type="text"
              className="form-control form-control-lg"
              placeholder="Nome de usuário"
              value={usuario}
              onChange={e => setUsuario(e.target.value)}
              required
              autoComplete="username"
            />
          </div>
          <div className="mb-3">
            <label className="form-label fw-semibold">Senha</label>
            <input
              type="password"
              className="form-control form-control-lg"
              placeholder="••••••••"
              value={senha}
              onChange={e => setSenha(e.target.value)}
              required
              autoComplete="current-password"
            />
          </div>
          <button type="submit" className="btn btn-primary login-submit-btn" disabled={loading}>
            {loading ? (
              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            ) : '🔑 Entrar'}
          </button>
        </form>
      </div>
    </div>
  );
}
